import { motion } from "framer-motion";

const images = [
  { url: "https://customer-assets.emergentagent.com/job_miss-lolly-designs/artifacts/tbx4j2t8_IMG_4157.jpeg", caption: "Sanrio Custom Coat", h: "tall" },
  { url: "https://customer-assets.emergentagent.com/job_miss-lolly-designs/artifacts/opf801d8_IMG_2658.jpeg", caption: "Lyric Collage Jacket", h: "tall" },
  { url: "https://customer-assets.emergentagent.com/job_miss-lolly-designs/artifacts/22257des_IMG_6302.jpeg", caption: "MLD Heart HTV", h: "med" },
  { url: "https://static.prod-images.emergentagent.com/jobs/8ce62d96-f600-4cc0-a5c9-9697f10f5a02/images/9299373664d2bc26dbfa3db427d6e1a388c0ca9ed797e7b4cf09dfa86a2ec286.png", caption: "Rhinestone & Stud Denim", h: "tall" },
];

const ratio = (h) => (h === "tall" ? "aspect-[3/4]" : h === "short" ? "aspect-[4/3]" : "aspect-square");

export default function Gallery() {
  return (
    <div data-testid="gallery-page" className="bg-ink">
      <section className="container-x section-y">
        <p className="overline">Studio archive</p>
        <h1 className="mt-4 font-display text-6xl md:text-8xl text-white">A wall of<br /><span className="text-rose">handmade.</span></h1>
        <p className="mt-6 max-w-2xl text-white/75 text-lg">
          One-of-a-kind drops from the studio — custom denim, HTV vinyl, rhinestones,
          studs and graphics. Each piece designed and pressed by Miss Lolly.
        </p>

        <div className="mt-14 masonry" data-testid="gallery-masonry">
          {images.map((im, i) => (
            <motion.figure
              key={im.url}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: (i % 6) * 0.05 }}
              data-testid={`gallery-item-${i}`}
              className={`overflow-hidden border-2 border-white bg-coal ${ratio(im.h)} group relative`}
            >
              <img src={im.url} alt={im.caption} loading="lazy"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
              <figcaption className="absolute inset-x-0 bottom-0 px-4 py-3 bg-ink/80 backdrop-blur-sm border-t-2 border-rose text-white text-xs font-bold uppercase tracking-wider opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                {im.caption}
              </figcaption>
            </motion.figure>
          ))}
        </div>

        <div className="mt-16 card-brutal-rose text-center">
          <p className="overline">Fresh drops</p>
          <h2 className="mt-3 font-display text-4xl md:text-5xl text-white">More pieces every workshop.</h2>
          <p className="mt-3 max-w-xl mx-auto text-white/75">
            Follow on Instagram and TikTok for behind-the-scenes presses, lyric jackets,
            denim reveals and studio chaos.
          </p>
        </div>
      </section>
    </div>
  );
}
